import styles from './CountdownTimer.module.css';

interface CountdownTimerProps {
  timeRemaining: number; // in seconds
  label: string;
  variant: 'agenda' | 'power-break';
}

export function CountdownTimer({ timeRemaining, label, variant }: CountdownTimerProps) {
  // Format time as HH:MM:SS or MM:SS based on duration
  const formatTime = (seconds: number): string => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    // Use HH:MM:SS format if duration >= 1 hour, otherwise MM:SS
    if (hours > 0) {
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    }
    return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  const formattedTime = formatTime(Math.max(0, timeRemaining));
  const isWarning = timeRemaining < 60 && timeRemaining > 0;

  return (
    <div className={styles.container}>
      <div className={styles.label}>{label}</div>
      <div 
        className={`${styles.time} ${styles[variant]} ${isWarning ? styles.warning : ''}`}
      >
        {formattedTime}
      </div>
    </div>
  );
}
